import KeyActions from './KeyActions.component';

export default KeyActions;
